import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { spacing, useCurrentTheme } from '@gitbook/react-uikit';

import { ContentKitStackDirectionContent } from './ContentKitStack';

export function ContentKitDivider(props: { element: api.ContentKitDivider }): React.ReactElement {
    const { element } = props;
    const direction = React.useContext(ContentKitStackDirectionContent);
    const [theme] = useCurrentTheme();
    const gap = spacing[element.size || 'medium'];

    return (
        <div
            className="shrink-0"
            style={
                direction === 'vstack'
                    ? {
                          backgroundColor: theme.colors.border.mid,
                          height: 1,
                          width: '100%',
                          marginBlock: gap,
                      }
                    : {
                          backgroundColor: theme.colors.border.mid,
                          height: '100%',
                          width: 1,
                          marginInline: gap,
                      }
            }
        />
    );
}
